import { FC, HTMLAttributes } from 'react';
import { useProductContext } from './useProductContext';
import cn from 'classnames';
import { toRecord } from 'base/utils/data';
import { useTrans } from 'base/utils/i18n';

export type IProductPricesProps = HTMLAttributes<HTMLDivElement>;

export const ProductPrices: FC<IProductPricesProps> = props => {
    const {
        product: {
            shopPrice,
            shopPriceExchangeDisplay,
            marketPriceExchangeDisplay,
            alterMarketPriceExchangeDisplay
        },
        prices
    } = useProductContext();

    const { t } = useTrans();

    if (prices === false) {
        return null;
    }
    const { showMarketPrice: configShowMarketPrice = true } = toRecord(prices);

    const { className } = props;
    const hasMarketPrice = shopPriceExchangeDisplay !== marketPriceExchangeDisplay;

    return (
        <div className={cn(className, 'g-prices')}>
            <strong className={cn('g-shop-price', { 'g-highlight': hasMarketPrice })}>
                {Number(shopPrice) === 0 ? t('web_price_free') : shopPriceExchangeDisplay}
            </strong>

            {!!alterMarketPriceExchangeDisplay && <span className="g-alter-price">{alterMarketPriceExchangeDisplay}</span>}

            {hasMarketPrice && configShowMarketPrice && (<del className="g-market-price">{marketPriceExchangeDisplay}</del>)}
        </div>
    )
};